import { useTranslation } from "react-i18next";

import { CircleCheckIcon, XIcon } from "lucide-react";

import { formatDateAt } from "simplydo/core/dates";
import type { IpStatementPrepared } from "simplydo/interfaces/types/ideaTypes";
import { styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";

import { useAppSelector } from "store";
import util from "utils/utils";

const IpStatementContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 0 1rem;
`;

const IpStatementItem = styled.div`
  border: 1px solid #e2e2e2;
  background-color: #fff;
  border-radius: 10px;
  padding: 0.5rem 1rem;
  min-width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  i {
    margin-right: 2rem;
  }
  .title {
    display: block;
    font-weight: 600;
  }
  .meta {
    display: block;
    color: #999999;
  }
  a {
    display: block;
  }
  .info-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
`;

type IPStatementInfoProps = { ipStatement: IpStatementPrepared };

const IPStatementInfo = ({ ipStatement }: IPStatementInfoProps) => {
  const user = useAppSelector((state) => state.user);
  const { userSignature, userSignedOn } = ipStatement;
  const { signedName, signedEmail } = userSignature || {};
  const { t } = useTranslation();
  if (!util.organisationFeaturesEnabled(user, ["ipManagement"])) return null;
  return (
    <IpStatementContainer>
      <IpStatementItem>
        <Icon
          icon={ipStatement.userHasSigned ? CircleCheckIcon : XIcon}
          color={ipStatement.userHasSigned ? "green" : "red"}
          size="large"
        />
        <div className="info-container">
          <span className="title">
            {ipStatement.userHasSigned
              ? `${t("common:capitalise", { key: "generic.idea" })} owner ${signedName} (${signedEmail}) has signed IP statement`
              : `${t("common:capitalise", { key: "generic.idea" })} owner has not signed latest IP statement`}
          </span>

          {ipStatement.userHasSigned ? (
            <span className="meta">Signed on {formatDateAt(userSignedOn)}</span>
          ) : null}
        </div>
      </IpStatementItem>
    </IpStatementContainer>
  );
};

export default IPStatementInfo;
